/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ActivityBulkSearchPageInternalRequest} from '@cash-web/protos/squareup/cash/activity/api/v1/search.pb'
import {ActivityBulkSearchPageInternalResponse} from '@cash-web/protos/squareup/cash/activity/api/v1/search.pb'


export const activityBulkSearchPageInternal = (request:ActivityBulkSearchPageInternalRequest, options?: CashRequestOptions) => post<ActivityBulkSearchPageInternalRequest, ActivityBulkSearchPageInternalResponse>("/2.0/cash/activity-bulk-search-page-internal", request, {...options, rejectOnError: true })